import { AuthApi } from '~/http/auth'
import { PropertyAPI } from '~/http/property'
import { OnlineReservationApi } from '~/http/setting/onlineReservation/booking'
import { PricingAPI } from '~/http/pricing'
import { VATClassificationsAPI } from '~/http/invoicing/VATClassifications'
import { AccountAssignmentsAPI } from '~/http/invoicing/accountAssignments'
import { ServiceClassificationsAPI } from '~/http/invoicing/serviceClassifications'
import { GtuCodesAPI } from '~/http/invoicing/gtuCodes'
import { UsersAPI } from '~/http/users'
import { RolesAPI } from '~/http/roles'

type useApi = {
  authApi: AuthApi
  usersAPI: UsersAPI
  rolesAPI: RolesAPI
  propertyAPI: PropertyAPI
  pricingAPI: PricingAPI
  onlineReservationApi: OnlineReservationApi
  VATClassificationAPI: VATClassificationsAPI
  accountAssignmentAPI: AccountAssignmentsAPI
  serviceClassificationAPI: ServiceClassificationsAPI
  gtuCodeAPI: GtuCodesAPI
}

/**
 * Only APIs that are truly global to the entire PMS belong here
 *
 * Other APIs should be placed into an http layer of its component or page.
 */
export const useAPI = (): useApi => {
  return {
    authApi: new AuthApi(),
    usersAPI: new UsersAPI(),
    rolesAPI: new RolesAPI(),
    propertyAPI: new PropertyAPI(),
    pricingAPI: new PricingAPI(),
    /** @deprecated should be moved to pages/ */
    onlineReservationApi: new OnlineReservationApi(),
    VATClassificationAPI: new VATClassificationsAPI(),
    accountAssignmentAPI: new AccountAssignmentsAPI(),
    serviceClassificationAPI: new ServiceClassificationsAPI(),
    gtuCodeAPI: new GtuCodesAPI(),
  }
}
